import { DataFeatures } from "./client.type";

// Business Rule : List of our functionalities
export enum EFeatures {
  PRODUCTDISPLAY = "productDisplay",
  ONLINEPAYMENT = "onlinePayment",
  ACCOUNT = "accountManagement",
  MAPS = "maps",
  RENT = "rental",
  BOOKINGAPPOINTMENT = "appointmentBooking",
  PUSHNOTIFICATION = "pushNotification",
  SHOPIFY = "shopify",
  LOYALTYCARD = "loyaltyCard",
  CHAT = "chat",
  HOPELIA = "hopelia",
  PAYPALLINK = "paypal",
}

export enum ESubscriptionPlan {
  BASIC = 'basic',    // 29€/mois - 10k crédits
  PRO = 'pro'        // 99€/mois - 50k crédits
}

export enum ESubscriptionStatus {
  ACTIVE = 'active',           // Payé et actif
  PENDING = 'pending',         // En attente de paiement  
  FAILED = 'failed',          // Paiement échoué
  CANCELLED = 'cancelled'      // Annulé par le client
}
export interface IFeaturesComponent {
  clientId: string;
  data: DataFeatures | undefined;
  params: IFeaturesConst;
}

export interface IFeaturesConst {
  id: EFeatures;
  name: string;
  component: (value: IFeaturesComponent) => JSX.Element;
  constants: any;
}

export interface IFeaturesLang {
  fr: IFeaturesConst[];
  en: IFeaturesConst[];
}
